import { css } from "glamor";
import React from "react";
import { Icon } from "semantic-ui-react";
import Link from "../library/Link";
import { colors, spacing, styles } from "../library/theme";

const listItem = css(styles.transition, {
  borderRadius: "10px",
  padding: spacing.s,
  display: "flex",
  gap: spacing.s,
  alignItems: "center",
  width: "100%",
  backgroundColor: colors.greyClear,
  color: `${colors.greyShadow} !important`,
  border: `1px solid ${colors.greyClear}`,
  ":hover": {
    color: `${colors.primary} !important`,
    border: `1px solid ${colors.primary}`,
  },
  "& + &": {
    marginTop: spacing.xxs,
  },
});

export default function CourseFiles(props) {
  return (
    <>
      {props.files.map((file, index) => {
        return (
          <Link
            key={index}
            href={file.url}
            target="_blank"
            className={listItem}
          >
            <div>
              <Icon name="cloud download" />{" "}
              {file.name || `Arquivo ${index + 1}`}
            </div>
          </Link>
        );
      })}
    </>
  );
}
